import React from 'react';
import { LeaderboardEntry } from '../types';
import { MedalIcon } from 'lucide-react';
interface LeaderboardTableProps {
  entries: LeaderboardEntry[];
  type: 'brawn' | 'brains';
}
export function LeaderboardTable({
  entries,
  type
}: LeaderboardTableProps) {
  const isBrawn = type === 'brawn';
  if (entries.length === 0) {
    return <div className="text-center py-12 text-gray-500" data-id="element-38">
        No scores recorded yet. Be the first!
      </div>;
  }
  const formatEntryScore = (entry: LeaderboardEntry) => {
    if (isBrawn) return `${entry.score} lbs`;
    return `${entry.score}s`;
  };
  return <div className="w-full overflow-hidden rounded-lg border border-zinc-800 bg-zinc-900/50" data-id="element-39">
      <table className="w-full text-left" data-id="element-40">
        <thead className={isBrawn ? 'bg-orange-950/30 text-orange-500' : 'bg-cyan-950/30 text-cyan-500'} data-id="element-41">
          <tr data-id="element-42">
            <th className="p-4 font-bold uppercase text-sm tracking-wider w-16" data-id="element-43">
              Rank
            </th>
            <th className="p-4 font-bold uppercase text-sm tracking-wider" data-id="element-44">
              Name
            </th>
            <th className="p-4 font-bold uppercase text-sm tracking-wider hidden sm:table-cell" data-id="element-45">
              Date
            </th>
            <th className="p-4 font-bold uppercase text-sm tracking-wider text-right" data-id="element-46">
              {isBrawn ? 'Score' : 'Time'}
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-zinc-800" data-id="element-47">
          {entries.map((entry, index) => <tr key={entry.id} className="hover:bg-white/5 transition-colors" data-id="element-48">
              <td className="p-4 text-gray-400 font-mono" data-id="element-49">
                {index === 0 ? <MedalIcon className="text-yellow-500 w-6 h-6" data-id="element-50" /> : index === 1 ? <MedalIcon className="text-gray-400 w-6 h-6" data-id="element-51" /> : index === 2 ? <MedalIcon className="text-amber-700 w-6 h-6" data-id="element-52" /> : `#${index + 1}`}
              </td>
              <td className="p-4 text-white font-medium text-lg" data-id="element-53">
                {entry.name}
              </td>
              <td className="p-4 text-gray-500 text-sm hidden sm:table-cell" data-id="element-54">
                {new Date(entry.date).toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric'
            })}
              </td>
              <td className={`p-4 text-right font-bold text-xl ${isBrawn ? 'text-orange-400' : 'text-cyan-400 font-mono'}`} data-id="element-55">
                {formatEntryScore(entry)}
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}